/* ========================================================================
   Sidebar Navigation
 ========================================================================== */

(function () {
  'use strict';

  function init() {
    // Disable on small screens
    const watchMedia = window.matchMedia('(min-width: 992px)');
    const stickyEl = document.querySelector('[data-sticky-nav]');
    const config = { el: stickyEl, edgeCssVar: '--container-max-width' };
    let stickyId = null;

    StickyManager.setGlobalTopOffset(80);

    if (watchMedia.matches) {
      // Enable sticky
      if (document.querySelector('scrollspy-nav')) {
        stickyId = StickyManager.add(config);
      }

      // Set scroll padding to match sticky header height
      document.documentElement.style.setProperty('--fixed-header-height', '80px');
    } else {
      // Set scroll padding to match sticky header + scrollnav height
      document.documentElement.style.setProperty('--fixed-header-height', '135px');
    }

    watchMedia.addEventListener('change', (event) => {
      if (event.matches) {
        // Enable sticky
        if (!stickyId) {
          stickyId = StickyManager.add(config);
        }

        // Set scroll padding to match sticky header height
        document.documentElement.style.setProperty('--fixed-header-height', '80px');
      } else {
        // Remove sticky
        if (stickyId) {
          StickyManager.remove(stickyEl);
          stickyId = null;
        }

        // Set scroll padding to match sticky header + scrollnav height
        document.documentElement.style.setProperty('--fixed-header-height', '135px');
      }
    });
  }

  init();
})();
